import { Button, ButtonProps } from './Button';

type ButtonWithIconProps = Omit<ButtonProps, 'icon'>;

export const ArrowButton = (
  props: ButtonWithIconProps & { direction?: 'right' | 'left' }
) => {
  const { direction = 'right' } = props;
  return (
    <Button
      type="button"
      {...(props as ButtonProps)}
      icon={direction === 'right' ? 'arrowright' : 'arrowleft'}
    />
  );
};

export const BoltButton = (props: ButtonWithIconProps) => (
  <Button {...(props as ButtonProps)} icon="bolt" />
);
